import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown as DD } from 'primereact/dropdown';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import useGetListAPI from 'modules/intakeforms/hooks/useGetListAPI';

export default function Role({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const { roles } = useGetListAPI();

  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, label, required } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field, fieldState }) => (
            <DD
              id={field.name}
              options={roles || []}
              optionLabel="relation_role"
              optionValue="relation_role_id"
              onChange={(e) => field.onChange(e.value)}
              value={field.value}
              placeholder="Select"
              disabled={String(field.value)?.toLowerCase() === 'client'}
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
              optionDisabled={(v) => String(v?.relation_role)?.toLowerCase() === 'client'}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
